import { useEffect } from 'react'

import { useSessionPhase, useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { useUserContext } from 'src/contexts/UserProvider'
import { analyticsService } from 'src/services/AnalyticsService'
import { isAppOpenedFromEmailLink } from 'src/utils/env'

export const useRootAnalytics = () => {
    const transcriptMetadata = useTranscriptMetadata()
    const { user, isUserFetched } = useUserContext()
    const sessionPhase = useSessionPhase()

    useEffect(() => {
        if (isUserFetched && transcriptMetadata) {
            analyticsService.setPageVisitContext({
                user,
                metadata: transcriptMetadata,
            })
        }
    }, [user, isUserFetched, transcriptMetadata])

    useEffect(() => {
        analyticsService.setCurrentSessionPhase(sessionPhase)
    }, [sessionPhase])

    useEffect(() => {
        if (isAppOpenedFromEmailLink()) {
            analyticsService.track('Generative AI - Email link opened', {})
        }
    }, [])

    useEffect(() => {
        if (!transcriptMetadata) {
            return
        }

        const { originalLanguageCode, translations, generativeAiEnabled } = transcriptMetadata
        analyticsService.track('TranslationsLanguagesLoaded', {
            languages: translations?.length ? translations.map(({ code }) => code) : [originalLanguageCode],
        })
        analyticsService.track('Generative AI - AIPanelAvailability', {
            isAvailable: generativeAiEnabled,
        })
    }, [transcriptMetadata])
}
